import { authConfig, AuthenticationStore } from "@istari-frontend/auth";
import axios, { AxiosPromise } from "axios";

import { isIdentityServiceEnabled } from "~/utils/identity-service";

const tokenEndpoint = isIdentityServiceEnabled()
  ? `${authConfig.authority}/oauth2/token`
  : `${authConfig.authority}/oauth/v2/token`;

function getNewAccessToken(refreshToken: string) {
  return axios.post(
    tokenEndpoint,
    {
      grant_type: "refresh_token",
      refresh_token: refreshToken,
      client_id: `${authConfig.client_id}`,
    },
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    },
  );
}

let refreshPromise: AxiosPromise | undefined;

export const refreshAccessToken = async () => {
  try {
    const AS = AuthenticationStore();
    const refreshToken = AS.getRefreshToken();

    refreshPromise = refreshPromise || getNewAccessToken(refreshToken);
    const response = await refreshPromise;

    const accessToken = response.data;

    return AS.saveAccessToken(accessToken);
  } catch (error) {
    return error;
  }
};
